<div class="cards-carousel" *ngIf="loaded" (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
    <div class="carousel-size"></div>
    <div class="cards-carousel-item" *ngFor="let sector of sectors; let i = index" [ngClass]="{
        'active': i == activeItem,
        'next': i == nextItem,
        'prev': i == prevItem
    }">
        <a [routerLink]="['/', translate.currentLang, 'sector', sector?.seo?.slug]" class="content" [style]="sector.backgroundImage">
            <div class="d-flex flex-column justify-content-between h-100 p-4">
                <div class="title">{{ translationHelper.localize(sector.name) }}</div>
                <div class="icon">
                    <svg-loader *ngIf="sector.icon" [SVGUrl]='sector.icon?.url'></svg-loader>
                </div>
            </div>
        </a>
    </div>
</div>